import React from "react";
import logo from "../../Assests/images/logo.jpg";
import { Link } from "react-router-dom";

const CartNavBar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg cart_nav">
        <div className="container-fluid" style={{ padding: "0px 5% 0px 5%" }}>
          <Link className="navbar-brand" to={"/"}>
            <img src={logo} alt="logo" width="120" height="53" />
          </Link>

          <div className="d-flex" style={{ gap: "10px" }}>
            <svg
              width="43"
              height="51"
              viewBox="0 0 43 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.3928 33.9288C18.8344 33.9288 18.2992 33.7097 17.903 33.3115L11.5816 26.9901C10.7577 26.1663 10.7577 24.8346 11.5816 24.0107C12.4055 23.1868 13.7372 23.1868 14.5611 24.0107L19.2516 28.7011L28.3102 17.8305C29.0561 16.9392 30.3815 16.8149 31.2792 17.5608C32.1726 18.3067 32.2927 19.6342 31.5489 20.5276L21.0132 33.1703C20.6339 33.6254 20.0818 33.8993 19.4897 33.9246L19.3928 33.9288ZM21.4999 50.7857L20.9879 50.7225C11.3814 48.3204 0.428467 34.8855 0.428467 25.5004V6.53642C0.428467 5.37329 1.37247 4.42931 2.53561 4.42931C5.42661 4.42931 9.77997 3.25986 15.2923 1.78067C17.0644 1.30446 18.9608 0.796649 20.9773 0.280407C21.3229 0.191909 21.6832 0.191909 22.0309 0.282514C23.8831 0.765043 25.6362 1.23914 27.2903 1.68796C32.9438 3.21983 37.4088 4.42931 40.4642 4.42931C41.6294 4.42931 42.5713 5.37329 42.5713 6.53642V25.5004C42.5713 35.0309 33.3589 48.4173 21.9192 50.7436L21.4999 50.7857ZM4.64275 8.51289V25.5004C4.64275 32.7299 13.9985 44.2558 21.5526 46.5104C30.4995 44.3569 38.357 33.1239 38.357 25.5004V8.51921C35.0741 8.1631 31.0474 7.06951 26.1883 5.75468C24.7049 5.35433 23.1414 4.92869 21.4957 4.49884C19.692 4.96451 17.9873 5.42175 16.3859 5.85161C11.6869 7.11166 7.7845 8.15889 4.64275 8.51289Z"
                fill="#25BC74"
              />
            </svg>
            <span className="secure_txt">100% Secure</span>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default CartNavBar;
